<!-- TagsInput.vue 分享邮件收件人输入框 -->
<template>
  <div class="muli-tags" @click='focus' :style="textbgShow?'':'border: 0.01rem solid #4681f1'" id="muli-tags">
    <div class="textTitle" v-if="title">{{title}}</div>
    <div class="textbg" v-if="tags.length<1 && textbgShow && (type=='email' || type=='filter')">{{message}}</div>
    <button class='btn' 
      v-for='(tag, index) in tags' 
      :key='index' 
      :title="tag.email"
      :class="tag.status=='error'?'muli-tag-error':''"
      :style="[tag.status=='error'?'background : #FFF3F3 !important;border-color : #FC7E7E !important;color : #FC7E7E !important;':'',type=='filter'?'':'padding-right: 0px !important;']"
      >{{tag.email|ellipsis}} <span @click='delTag(index)' class="tag-input-delet-icon" style="margin-left:3px;vertical-align:middle;"></span>
    </button>
    <input type="text"
      ref='input'
      @keyup.enter="add"
      @keydown.space="split" 
      @keydown.delete="del"
      @keydown.188='split'
      v-model='current' 
      @blur="showTextbg"
      @focus="showTextbg"
      :placeholder="(tags.length<1 && textbgShow && type=='invite')?message:''" 
      :style="textbgShow?'width:10px;':''" 
      autocomplete="off" 
      v-clearEmoji
      >
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    required: true,
    title: "",
    message: "",
    type: "",
    default: () => []
  },
   data() {
        return {
          textbgShow: false
        }
   },
   watch: {
     tags(val){
       //输入邮箱超过50个，取消输入并进行提示
       if(val.length&&val.length>50){
        val = val.splice(val.length-1,1);
        this.$toast({
          text: this.$t('language.popup.cloudExploerPopup.emailArrayToLong50'),
          type: "notice",
          idValue: "share"
        });
       }
     }
   },
  methods: {
    focus () {
      this.$refs.input.focus()
    },
    split (e) {
      e.preventDefault()
      this.add(e)
    },
    add (e) {
      const val = e.target.value.trim()
      if (!val) return
      if (this.tags.indexOf(val) > -1) return
      if(this.tags.length>=50){
        this.$toast({
          text: this.$t('language.popup.cloudExploerPopup.emailArrayToLong50'),
          type: "notice",
          idValue: "share"
        });
        return;
      }
      this.tags.push({'email':val,'status':'default'})
      this.$emit('input', this.tags)
      this.current = ''
    },
    del (e) {
      if (!e.target.value.length) {
        this.tags.pop()
        this.$emit('input', this.tags)
      }
    },
    delTag (index) {
      this.tags.splice(index, 1)
      this.$emit('input', this.tags)
    },
    showTextbg (e) {
      //移出焦点触发add
      if(e.target.value && !this.textbgShow) {
        this.add(e);
      }
      this.textbgShow = !this.textbgShow
    }
  },
  computed: {
    tags () {
      return this.value?this.value.slice():[]
    }
  },
  data () {
    return {
      current: '',
      textbgShow: 'true'
    }
  },
  filters: {
    //设置路径的过滤器
    ellipsis(value) {
        let subStr;
        if (!value) return '';
        if (value.length > 12) {
          let at = value.indexOf('@');
          if(at>=0){
            let befor = value.slice(0, at);
            let next = value.slice(at, value.length);
            if(befor.length>12){
              befor = befor.slice(0, 6) + '...' + befor.slice(befor.length - 2, befor.length);
            }
            if(next.length>12){
              next = next.slice(0, 3) + '...' + next.slice(next.length - 6, next.length);
            }
            subStr = befor+next;
          }else{
            subStr = value.slice(0, 6) + '...' + value.slice(value.length - 2, value.length)
          }
        } else {
            subStr = value;
        }
        return subStr;
        }
    }
}
</script>

<style lang='less' scoped>
.muli-tags{
  //padding: 0px 0.1rem;
  display: block;
  border: 0.01rem solid #e0eaf9;
  max-height: 0.8rem;
  overflow: auto;
  input{
      color:black;
    background: transparent;
    position:relative;
  }
  .btn{
      color:black;
    margin: 5px 5px 5px 5px;
    padding: 4px 5px;/*no*/
    background: #DAE8FF;
    border: 1px solid #DAE8FF;/*no*/
    //box-shadow:  0 0 4px;
    border-radius: 5px;
    position: relative;
    &.muli-tag-error {
      background : #FFF3F3 !important;
      border-color : #FC7E7E !important;
      color : #FC7E7E !important;
    }
  }
  input {
      width: auto;
      height: 15px;
      border: 0px;/*no*/
      margin-top: 0px;/*no*/
      padding-left: 0.1rem;
  }
  button {
      height: 22px;
  }
  .textbg {
    position: absolute;
    left: 30px;
    width: auto;
    height: 30px;/*no*/
    z-index: -1;
    color: #cccccf;
  }
  input:focus {
    border : 0px;
  }
}

#muli-tags::-webkit-scrollbar{
  width: 0.08rem;
  height: 0px;
  background-color: #fff;
}

#muli-tags::-webkit-scrollbar-thumb{
  height: 0.01rem;
  border-radius: 5px;
  background-color: #becae4;
}

#muli-tags .textTitle{
  float: left;
  min-width: 40px;/*no*/
}
</style>


// WEBPACK FOOTER //
// src/components/common/input/tag_input.vue